import React, { Component, createRef } from "react";
import { t } from "../../Helper/i18n";

// CSS
import "../../styles/newDesign.scss";
import "./Live.scss";

// Components
import Header from "../../components/Header/Header";

// Helper
import { resolveTenant, isLoggedIn, joinMeeting, meetingChatHistory, meetingChatSend, meetingPolls, meetingVote, meetingTamper } from "../../Helper/Api";
import { loadMeetingRoom } from "../../Helper/meetingScripts";
import Toast from "../../components/Toast/Toast";

const properties = require("../../properties.json");

// A student inside a live session: gets a join token (POST /meetings/{id}/join) and hands it to the shared room UI.
class LiveRoom extends Component {
  constructor(props) {
    super(props);
    this.box = createRef(null);
    this.handle = null;
  }

  state = { tenant: null, error: null };

  componentDidMount() {
    if (!isLoggedIn()) {
      window.location.href = "/sign-in";
      return;
    }
    const id = this.props.match.params.id;
    resolveTenant()
      .then((tenant) => {
        document.title = properties.site_name + " - " + t("liveTitle");
        this.setState({ tenant });
        return Promise.all([loadMeetingRoom(), joinMeeting(id)]);
      })
      .then(([Room, info]) => {
        if (!this.box.current) return;
        this.handle = Room.mount(this.box.current, info, {
          onLeave: () => { window.location.href = "/live"; },
          // chat kept on the server: a late joiner reads what was said before
          chat: {
            history: (after) => meetingChatHistory(id, after),
            send: (text, clientId) => meetingChatSend(id, text, clientId),
            setLocked: () => Promise.resolve(),
          },
          reportTamper: (detail) => meetingTamper(id, detail),
          polls: {
            list: () => meetingPolls(id),
            vote: (pollId, option) => meetingVote(id, pollId, option),
          },
        });
      })
      .catch((e) => this.setState({ error: e.message || String(e) }));
  }

  componentWillUnmount() {
    if (this.handle) this.handle.leave();
  }

  render() {
    const { tenant, error } = this.state;
    return (
      <>
        {tenant && <Header tenant={tenant} />}
        <div className="nd-page">
          <div className="nd-section lv-room-wrap">
            <a className="lv-back" href="/live">{t("backToLive")}</a>
            <Toast msg={error} type="warning" />
            <div ref={this.box} className="lv-room" />
          </div>
        </div>
      </>
    );
  }
}

export default LiveRoom;
